import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { STORE_CONFIG } from "../config/storeConfig";
import "../css/paysuccess.css";

const states = {
  success: { title: "Payment return received", tone: "pending", message: "You returned from the hosted payment page. This browser state is not proof that funds have settled. Your order should be fulfilled only after server-side payment confirmation." },
  cancel: { title: "Payment was not completed", tone: "cancel", message: "The hosted payment flow was cancelled or could not continue. Your cart remains available, and you have not been charged by this page." },
  failure: { title: "Payment could not be started", tone: "failure", message: "The hosted payment service did not return a usable session. Check the order details and try again, or contact support without sending card credentials." },
};

function PaymentResult() {
  const [searchParams] = useSearchParams();
  const state = states[searchParams.get("state")] || states.failure;
  return (
    <main className="payment-result main">
      <div className={`payment-result__card payment-result__card--${state.tone}`}>
        <span className="payment-result__icon" aria-hidden="true">{state.tone === "pending" ? "…" : "×"}</span>
        <p className="payment-result__eyebrow">Hosted payment status</p>
        <h1>{state.title}</h1><p>{state.message}</p>
        <div className="payment-result__actions"><Link to="/cartpage" className="button-link">Return to cart</Link><Link to="/shop" className="text-link">Continue shopping</Link></div>
        <p className="payment-result__help">Need help? <a href={`mailto:${STORE_CONFIG.supportEmail}`}>{STORE_CONFIG.supportEmail}</a></p>
      </div>
    </main>
  );
}

export default PaymentResult;
